module.exports = __webpack_public_path__ + "static/media/garuda_logo.587ba3f2.jpg";